import React from "react";
import '../styles/about.css';
import PageHeader from "./PageHeader";
import almas_address from "../pages/address/almas_address";

const About = () => {
    const site = process.env.REACT_APP_CLIENT_NAME;
    let address;
    switch (site) {
        case "almas":
            address = almas_address;
            break;
        default:
            address = "";
    }
    return (
        <div className="about-page">
            <PageHeader title="About US" />
            <div className="about-section">
                <span className="about-heading">Our Mission</span>
                <p>To provide advanced and quality healthcare services accessible to the public, we are committed to delivering compassionate and value-based care. In pursuit of our mission, we aim to promote healthcare awareness among the public, engage in clinical research, and facilitate the education of healthcare professionals. With the overarching goal of evolving into a quaternary-level hospital, our commitment extends to serving both domestic and international patients.</p>

                <p>നൂതനവും ഗുണമേന്മയുള്ള ആരോഗ്യ സേവനങ്ങൾ നൽകി, അനുകമ്പയോടും മൂല്യബോധത്തോടും കൂടി രോഗികളെ പരിചരിക്കുക, ആരോഗ്യ സംരക്ഷണത്തിന്റെ മികച്ച അവബോധം സൃഷ്ടിക്കുക, ആരോഗ്യ സംരക്ഷണ പ്രൊഫഷണലുകളുടെ ക്ലിനിക്കൽ ഗവേഷണവും വിദ്യാഭ്യാസവും പ്രോത്സാഹിപ്പിക്കുക, ഒരു ക്വാട്ടർണറിതലത്തിലുള്ള ആശുപത്രിയായി വികസിക്കുക, പ്രാദേശിക ആഗോള രോഗികൾക്ക് സേവനം നൽകുക എന്നതാണ് ഞങ്ങളുടെ ദൗത്യം.</p>

                <span className="about-heading">Our Vision</span>
                <p>To provide our patients with world class health care services at an affordable cost, promote health care awareness, engage in healthcare education, and evolve as a quaternary care centre.</p>

                <p>ലോകോത്തര നിലവാരമുള്ള ചികിത്സ മിതമായ നിരക്കിൽ രോഗികൾക്കു നൽകുകയും ആരോഗ്യപരമായ അറിവുകൾക്കും വിദ്യാഭ്യാസത്തിനും മുൻതൂക്കം കൊടുക്കുകയും വിപുലമായ ആരോഗ്യ ചികിത്സ കേന്ദ്രമായി ഉയരുകയും ചെയ്യുക എന്നതാണ് ഞങ്ങളുടെ സ്ഥായിയായലക്ഷ്യം.</p>
                <div dangerouslySetInnerHTML={{__html:address}}>

                </div>
            </div>
        </div>
    )
}
export default About;